import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BUTTON_TYPES } from 'src/app/components/shared/modal/components/modal-frame/modal-frame.constants';
import { BUTTON_CLICK } from 'src/app/components/shared/modal/exit-modal/exit-modal.constants';
import { CONFIRM_BUTTON } from 'src/app/components/shared/shared-constants';
import { DeleteDeviceAdmin } from 'src/app/core/models/admin/device-admin.model';
import { CONSTS } from './delete-device.constants';

@Component({
  selector: 'app-delete-device',
  templateUrl: './delete-device.component.html',
  styleUrls: ['./delete-device.component.scss'],
  standalone: false,
})
export class DeleteDeviceComponent {
  public data = inject<DeleteDeviceAdmin>(MAT_DIALOG_DATA);
  private dialogRef = inject(MatDialogRef<DeleteDeviceComponent>);

  readonly CONSTS = CONSTS;
  readonly BUTTON_CLICK = BUTTON_CLICK;
  readonly BUTTON_TYPES = BUTTON_TYPES;
  readonly CONFIRM_BUTTON = CONFIRM_BUTTON;

  onClose(button: BUTTON_CLICK): void {
    if (button === BUTTON_CLICK.ACCEPT) {
      this.dialogRef.close(this.data?.id);
    } else {
      this.dialogRef.close();
    }
  }
}
